import {
  callHelpLogout,
  callHelpSwitchFactory,
  callHelpSwitchLanguage,
  callHelpViewProfile,
  callHelpWhereOnlineListAfterLoginSuccess,
  callHelpOnlineListWhenLoginCheck,
} from '@/js/help/layout';

import {
  callHelpEditFactory,
  callHelpDeleteFactory,
  callHelpAddFactory,
  callHelpFilterFactory,
  callHelpCreateReviewSchedule,
  callHelpEditReviewSchedule,
  callHelpDeleteReviewSchedule,
  callHelpFilterReviewSchedule,
  callHelpNextExecuteSchedule,
  callHelpSystemKey,
  callHelpCreateBasicAuthoritySetting,
  callHelpEditBasicAuthoritySetting,
  callHelpAuthorityUpdate,
  callHelpDeleteBasicAuthoritySetting,
  callHelpFilterBasicAuthoritySetting,
  callHelpCreateBuUser,
  callHelpEditBuUser,
  callHelpDeleteBuUser,
  callHelpFilterBuUser,
  callHelpCreateAccount,
  callHelpEditAccount,
  callHelpDeleteAccount,
  callHelpFilterAccount,
  callHelpSyncAccount,
  callHelpModifyPassword,
  callHelpDataImport,
  callHelpAccountManagementTemplate,
  callHelpBuUserSettingTemplate,
  callHelpMailNotify,
  callHelpWeChatNotify,
} from '@/js/help/system';

import { callHelpLogin, callHelpNoAccount, callHelpSPCLoginError } from '../login';

import {
  callHelpDashboard,
  callHelpSamplePointView,
  callHelpMenuOtherFunction,
} from '../dashboard';

import {
  callHelpUserGroupSettingsCreate,
  callHelpUserGroupSettingsEdit,
  callHelpUserGroupSettingsUser,
  callHelpUserGroupSettingsPermission,
  callHelpUserGroupSettingsForbidden,
  callHelpUserGroupSettingsOther,
  callHelpDeleteUserGroupSettings,
  callHelpFilterUserGroupSettings,
  callHelpCreateUserSettings,
  callHelpViewUserSettings,
  callHelpUserSettingsGroup,
  callHelpUserSettingsPermission,
  callHelpUserSettingsForbidden,
  callHelpUserSettingsOtherFunction,
  callHelpDeleteUserSettings,
  callHelpFilterUserSettings,
  callHelpNotificationSettings,
  callHelpEditNotificationSettings,
  callHelpNotificationSettingsGroup,
  callHelpNotificationSettingsMember,
  callHelpDeleteNotificationSettings,
  callHelpFilterNotificationSettings,
} from '../memberManagement';

import {
  callHelpFilterControlItemTree,
  callHelpCreateControlItem,
  callHelpCreateControlItemV1,
  callHelpDoubleChart,
  callHelpCopy,
  callHelpReCaculate,
  callHelpEdit,
  callHelpDelete,
  callHelpExplanationOfTheTerm,
  callHelpViewControlProject,
  callHelpFilterControlProject,
  callHelpHidePoionOpen,
  clickChartSamplePoint,
  callControlItemEntry,
  callDataImport,
  callMultiDataImport,
  callSampleManagement,
  callSampleManagementEditPointProcess,
  callControlLineChangeHistory,
  callControlChartRuleHistory,
  callCombinedQuery,
  callProcessAnalysis,
  callProcessAnalysisAdvanceSearch,
  callProcessAnalysisChartQuery,
  callProcessAnalysisAbnormal,
  callHelpControlChartDataType,
  callxBarChart,
} from '../controllItem';

import {
  callHelpAbnormalReasonManagement,
  callHelpEditAbnormalReasonManagement,
  callHelpDeleteAbnormalReasonManagement,
  callHelpDefectDefinition,
  callHelpEditDefectDefinition,
  callHelpDeleteDefectDefinition,
  callHelpInspection,
  callHelpEditInspection,
  callHelpDeleteInspection,
  callHelpLevelProduct,
  callHelpLevelProductEdit,
  callHelpLevelProductDelete,
  callHelpLevelMachine,
  callHelpLevelMachineEdit,
  callHelpLevelMachineDelete,
  callHelpLevelProcess,
  callHelpLevelProcessEdit,
  callHelpLevelProcessDelete,
  callHelpLevelParams,
  callHelpLevelParamsEdit,
  callHelpLevelParamsDelete,
  callHelpDynamicFieldSettings,
  callHelpControlChartRules,
  callHelpControlChartRulesEditAndDelete,
  callHelpGoldenSampleSetting,
  callHelpGoldenSampleSettingEditAndDelete,
  callHelpProcessAnalysisRanks,
  callHelpProcessAnalysisRanksEditAndDelete,
  callHelpIndicator,
  callHelpIndicatorQA,
  callHelpScheduleSettings,
  callHelpScheduleSettingsList,
  callHelpProcessAnalysisRule,
  callHelpProcessAnalysisRuleEditAndDelete,
} from '../settingManagement';

import {
  callHelpStageSetting,
  callHelpEditDeleteStageSetting,
  callHelpFlowSetting,
  callHelpOCAPSettingExample,
  callHelpSignatureQuery,
  callHelpSignatureQueryHandle,
} from '../ocap';

import {
  callHelpAlertList,
  callHelpAlertListAdvanceSearch,
  callHelpAlertListLamp,
  callHelpAlertListHandle,
  callProcessAnalysisAlarmList,
} from '../alertManagement';

import {
  callHelpDataProcessingImport,
  callHelpDataImportAbnormalReason,
  callHelpDataImportDefect,
  callHelpDataImportInspection,
  callHelpDataImportControlChartRules,
  callHelpDataImportUserSettings,
  callHelpDataImportUserGroup,
  callHelpDataImportParameters,
  callHelpDataImportGroup,
  callHelpDataImportMachine,
  callHelpDataImportProduct,
  callHelpControlItemImport,
  callHelpBatchImport,
} from '../dataProcessing';

/**
 * 開啟導覽旅程之協助(System)
 * @param {*} clickId
 * @param {*} param1
 */
export function openHelpDriverTourSystem(clickId, { store, route, router, i18n }) {
  console.log('目前路由：', route.path);
  console.log('clickId', clickId);

  switch (clickId) {
    case 'selectLanguage':
      callHelpSwitchLanguage(i18n);
      break;

    case 'switchFactory':
      callHelpSwitchFactory(i18n);
      break;

    case 'where_online_list':
      callHelpWhereOnlineListAfterLoginSuccess(i18n, store);
      break;

    case 'viewProfile':
      callHelpViewProfile(i18n, store);
      break;

    case 'logout':
      callHelpLogout(i18n);
      break;

    case 'addFactory':
      if (route.path === '/system/As_2') {
        callHelpAddFactory(i18n, store);
      } else {
        router.push('/system/As_2');

        setTimeout(() => {
          callHelpAddFactory(i18n, store);
        }, 2000);
      }
      break;

    case 'editFactory':
      if (route.path === '/system/As_2') {
        callHelpEditFactory(i18n);
      } else {
        router.push('/system/As_2');

        setTimeout(() => {
          callHelpEditFactory(i18n);
        }, 2000);
      }
      break;

    case 'deleteFactory':
      if (route.path === '/system/As_2') {
        callHelpDeleteFactory(i18n);
      } else {
        router.push('/system/As_2');

        setTimeout(() => {
          callHelpDeleteFactory(i18n);
        }, 2000);
      }
      break;

    case 'filterFactory':
      if (route.path === '/system/As_2') {
        callHelpFilterFactory(i18n);
      } else {
        router.push('/system/As_2');

        setTimeout(() => {
          callHelpFilterFactory(i18n, store);
        }, 2000);
      }
      break;

    case 'createSeasonSetting':
      if (route.path === '/system/As_3') {
        callHelpCreateReviewSchedule(i18n, store);
      } else {
        router.push('/system/As_3');
        setTimeout(() => {
          callHelpCreateReviewSchedule(i18n, store);
        }, 2000);
      }
      break;

    case 'editSeasonSetting':
      if (route.path === '/system/As_3') {
        callHelpEditReviewSchedule(i18n, store);
      } else {
        router.push('/system/As_3');
        setTimeout(() => {
          callHelpEditReviewSchedule(i18n, store);
        }, 2000);
      }
      break;

    case 'deleteSeasonSetting':
      if (route.path === '/system/As_3') {
        callHelpDeleteReviewSchedule(i18n, store);
      } else {
        router.push('/system/As_3');
        setTimeout(() => {
          callHelpDeleteReviewSchedule(i18n, store);
        }, 2000);
      }
      break;

    case 'filterSeasonSetting':
      if (route.path === '/system/As_3') {
        callHelpFilterReviewSchedule(i18n, store);
      } else {
        router.push('/system/As_3');
        setTimeout(() => {
          callHelpFilterReviewSchedule(i18n, store);
        }, 2000);
      }
      break;

    case 'nextExecuteSchedule':
      if (route.path === '/system/As_3') {
        callHelpNextExecuteSchedule(i18n, store);
      } else {
        router.push('/system/As_3');
        setTimeout(() => {
          callHelpNextExecuteSchedule(i18n, store);
        }, 2000);
      }
      break;

    case 'systemKey':
      if (route.path === '/system/As_5') {
        callHelpSystemKey(i18n, store);
      } else {
        router.push('/system/As_5');
        setTimeout(() => {
          callHelpSystemKey(i18n, store);
        }, 2000);
      }
      break;

    case 'createBasicAuthoritySetting':
      if (route.path === '/system/Bs_1') {
        callHelpCreateBasicAuthoritySetting(i18n, store);
      } else {
        router.push('/system/Bs_1');
        setTimeout(() => {
          callHelpCreateBasicAuthoritySetting(i18n, store);
        }, 2000);
      }
      break;

    case 'editBasicAuthoritySetting':
      if (route.path === '/system/Bs_1') {
        callHelpEditBasicAuthoritySetting(i18n);
      } else {
        router.push('/system/Bs_1');
        setTimeout(() => {
          callHelpEditBasicAuthoritySetting(i18n);
        }, 2000);
      }
      break;

    case 'authority':
      if (route.path === '/system/Bs_1') {
        callHelpAuthorityUpdate(i18n, store);
      } else {
        router.push('/system/Bs_1');
        setTimeout(() => {
          callHelpAuthorityUpdate(i18n, store);
        }, 2000);
      }
      break;

    case 'deleteBasicAuthoritySetting':
      if (route.path === '/system/Bs_1') {
        callHelpDeleteBasicAuthoritySetting(i18n);
      } else {
        router.push('/system/Bs_1');
        setTimeout(() => {
          callHelpDeleteBasicAuthoritySetting(i18n);
        }, 2000);
      }
      break;

    case 'filterBasicAuthoritySetting':
      if (route.path === '/system/Bs_1') {
        callHelpFilterBasicAuthoritySetting(i18n);
      } else {
        router.push('/system/Bs_1');
        setTimeout(() => {
          callHelpFilterBasicAuthoritySetting(i18n);
        }, 2000);
      }
      break;

    case 'createBuUser':
      if (route.path === '/system/Bs_2') {
        callHelpCreateBuUser(i18n, store);
      } else {
        router.push('/system/Bs_2');
        setTimeout(() => {
          callHelpCreateBuUser(i18n, store);
        }, 2000);
      }
      break;

    case 'editBuUser':
      if (route.path === '/system/Bs_2') {
        callHelpEditBuUser(i18n);
      } else {
        router.push('/system/Bs_2');
        setTimeout(() => {
          callHelpEditBuUser(i18n);
        }, 2000);
      }
      break;

    case 'deleteBuUser':
      if (route.path === '/system/Bs_2') {
        callHelpDeleteBuUser(i18n);
      } else {
        router.push('/system/Bs_2');
        setTimeout(() => {
          callHelpDeleteBuUser(i18n);
        }, 2000);
      }
      break;

    case 'filterBuUser':
      if (route.path === '/system/Bs_2') {
        callHelpFilterBuUser(i18n);
      } else {
        router.push('/system/Bs_2');
        setTimeout(() => {
          callHelpFilterBuUser(i18n);
        }, 2000);
      }
      break;

    case 'createAccount':
      if (route.path === '/system/Bs_3') {
        callHelpCreateAccount(i18n, store);
      } else {
        router.push('/system/Bs_3');
        setTimeout(() => {
          callHelpCreateAccount(i18n, store);
        }, 2000);
      }
      break;

    case 'editAccount':
      if (route.path === '/system/Bs_3') {
        callHelpEditAccount(i18n);
      } else {
        router.push('/system/Bs_3');
        setTimeout(() => {
          callHelpEditAccount(i18n);
        }, 2000);
      }
      break;

    case 'modifyPassword':
      if (route.path === '/system/Bs_3') {
        callHelpModifyPassword(i18n);
      } else {
        router.push('/system/Bs_3');
        setTimeout(() => {
          callHelpModifyPassword(i18n);
        }, 2000);
      }
      break;

    case 'deleteAccount':
      if (route.path === '/system/Bs_3') {
        callHelpDeleteAccount(i18n);
      } else {
        router.push('/system/Bs_3');
        setTimeout(() => {
          callHelpDeleteAccount(i18n);
        }, 2000);
      }
      break;

    case 'filterAccount':
      if (route.path === '/system/Bs_3') {
        callHelpFilterAccount(i18n);
      } else {
        router.push('/system/Bs_3');
        setTimeout(() => {
          callHelpFilterAccount(i18n);
        }, 2000);
      }
      break;

    case 'syncAccount':
      if (route.path === '/system/Bs_3') {
        callHelpSyncAccount(i18n);
      } else {
        router.push('/system/Bs_3');
        setTimeout(() => {
          callHelpSyncAccount(i18n);
        }, 2000);
      }
      break;

    case 'dataImport':
      if (route.path === '/system/Bs_4') {
        callHelpDataImport(i18n, store);
      } else {
        router.push('/system/Bs_4');
        setTimeout(() => {
          callHelpDataImport(i18n, store);
        }, 2000);
      }
      break;

    case 'accountManagementExcel':
      if (route.path === '/system/Bs_4') {
        callHelpAccountManagementTemplate(i18n);
      } else {
        router.push('/system/Bs_4');
        setTimeout(() => {
          callHelpAccountManagementTemplate(i18n);
        }, 2000);
      }
      break;

    case 'buUserSettingManagementExcel':
      if (route.path === '/system/Bs_4') {
        callHelpBuUserSettingTemplate(i18n);
      } else {
        router.push('/system/Bs_4');
        setTimeout(() => {
          callHelpBuUserSettingTemplate(i18n);
        }, 2000);
      }
      break;

    case 'mailNotify':
      if (route.path === '/system/Cs_2') {
        callHelpMailNotify(i18n);
      } else {
        router.push('/system/Cs_2');
        setTimeout(() => {
          callHelpMailNotify(i18n);
        }, 2000);
      }
      break;

    case 'weChatNotify':
      if (route.path === '/system/Cs_3') {
        callHelpWeChatNotify(i18n);
      } else {
        router.push('/system/Cs_3');
        setTimeout(() => {
          callHelpWeChatNotify(i18n);
        }, 2000);
      }
      break;

    default:
      break;
  }
}

/**
 * 開啟導覽旅程之協助(Login)
 * @param {*} clickId
 * @param {*} param1
 */
export function openHelpDriverTourLogin(clickId, { i18n, store }) {
  switch (clickId) {
    case 'login':
      callHelpLogin(i18n);
      break;

    case 'explain_noAccount':
      callHelpNoAccount(i18n);
      break;

    case 'explain_SPCLoginError':
      callHelpSPCLoginError(i18n);
      break;

    case 'onlineList':
      callHelpOnlineListWhenLoginCheck(i18n, store);
      break;

    default:
      break;
  }
}

/**
 * 開啟導覽旅程之協助(儀表板、廠區)
 * @param {*} clickId
 * @param {*} param1
 */
export function openHelpDriverTourBU(clickId, { store, route, router, i18n }) {
  switch (clickId) {
    case 'dashboard':
      if (route.path === '/index') {
        callHelpDashboard(i18n, store);
      } else {
        router.push('/index');
        setTimeout(() => {
          callHelpDashboard(i18n, store);
        }, 2000);
      }
      break;

    case 'samplePointView':
      if (route.path === '/index') {
        callHelpSamplePointView(i18n, store);
      } else {
        router.push('/index');
        setTimeout(() => {
          callHelpSamplePointView(i18n, store);
        }, 2000);
      }
      break;

    case 'menuOtherFunction':
      callHelpMenuOtherFunction(i18n, store);
      break;

    //
    // 人員管理
    //

    case 'userGroupSettings':
      if (route.path === '/C_1') {
        callHelpUserGroupSettingsCreate(i18n, store);
      } else {
        router.push('/C_1');
        setTimeout(() => {
          callHelpUserGroupSettingsCreate(i18n, store);
        }, 2000);
      }
      break;

    case 'editUserGroupSettings':
      if (route.path === '/C_1') {
        callHelpUserGroupSettingsEdit(i18n, store);
      } else {
        router.push('/C_1');
        setTimeout(() => {
          callHelpUserGroupSettingsEdit(i18n, store);
        }, 2000);
      }
      break;

    case 'userGroupSettingsUser':
      if (route.path === '/C_1') {
        callHelpUserGroupSettingsUser(i18n, store);
      } else {
        router.push('/C_1');
        setTimeout(() => {
          callHelpUserGroupSettingsUser(i18n, store);
        }, 2000);
      }
      break;

    case 'userGroupSettingsPermission':
      if (route.path === '/C_1') {
        callHelpUserGroupSettingsPermission(i18n, store);
      } else {
        router.push('/C_1');
        setTimeout(() => {
          callHelpUserGroupSettingsPermission(i18n, store);
        }, 2000);
      }
      break;

    case 'userGroupSettingsForbidden':
      if (route.path === '/C_1') {
        callHelpUserGroupSettingsForbidden(i18n, store);
      } else {
        router.push('/C_1');
        setTimeout(() => {
          callHelpUserGroupSettingsForbidden(i18n, store);
        }, 2000);
      }
      break;

    case 'userGroupSettingsOther':
      if (route.path === '/C_1') {
        callHelpUserGroupSettingsOther(i18n, store);
      } else {
        router.push('/C_1');
        setTimeout(() => {
          callHelpUserGroupSettingsOther(i18n, store);
        }, 2000);
      }
      break;

    case 'deleteUserGroupSettings':
      if (route.path === '/C_1') {
        callHelpDeleteUserGroupSettings(i18n, store);
      } else {
        router.push('/C_1');
        setTimeout(() => {
          callHelpDeleteUserGroupSettings(i18n, store);
        }, 2000);
      }
      break;

    case 'filterUserGroupSettings':
      if (route.path === '/C_1') {
        callHelpFilterUserGroupSettings(i18n);
      } else {
        router.push('/C_1');
        setTimeout(() => {
          callHelpFilterUserGroupSettings(i18n);
        }, 2000);
      }
      break;

    case 'userSettings':
      if (route.path === '/C_2') {
        callHelpCreateUserSettings(i18n, store);
      } else {
        router.push('/C_2');
        setTimeout(() => {
          callHelpCreateUserSettings(i18n, store);
        }, 2000);
      }
      break;

    case 'viewUserSettings':
      if (route.path === '/C_2') {
        callHelpViewUserSettings(i18n);
      } else {
        router.push('/C_2');
        setTimeout(() => {
          callHelpViewUserSettings(i18n);
        }, 2000);
      }
      break;

    case 'userSettingsGroup':
      if (route.path === '/C_2') {
        callHelpUserSettingsGroup(i18n, store);
      } else {
        router.push('/C_2');
        setTimeout(() => {
          callHelpUserSettingsGroup(i18n, store);
        }, 2000);
      }
      break;

    case 'userSettingsPermission':
      if (route.path === '/C_2') {
        callHelpUserSettingsPermission(i18n, store);
      } else {
        router.push('/C_2');
        setTimeout(() => {
          callHelpUserSettingsPermission(i18n, store);
        }, 2000);
      }
      break;

    case 'userSettingsForbidden':
      if (route.path === '/C_2') {
        callHelpUserSettingsForbidden(i18n, store);
      } else {
        router.push('/C_2');
        setTimeout(() => {
          callHelpUserSettingsForbidden(i18n, store);
        }, 2000);
      }
      break;

    case 'userSettingsOtherFunction':
      if (route.path === '/C_2') {
        callHelpUserSettingsOtherFunction(i18n, store);
      } else {
        router.push('/C_2');
        setTimeout(() => {
          callHelpUserSettingsOtherFunction(i18n, store);
        }, 2000);
      }
      break;

    case 'deleteUserSettings':
      if (route.path === '/C_2') {
        callHelpDeleteUserSettings(i18n, store);
      } else {
        router.push('/C_2');
        setTimeout(() => {
          callHelpDeleteUserSettings(i18n, store);
        }, 2000);
      }
      break;

    case 'filterUserSettings':
      if (route.path === '/C_2') {
        callHelpFilterUserSettings(i18n);
      } else {
        router.push('/C_2');
        setTimeout(() => {
          callHelpFilterUserSettings(i18n);
        }, 2000);
      }
      break;

    case 'notificationSettings':
      if (route.path === '/D_2') {
        callHelpNotificationSettings(i18n, store);
      } else {
        router.push('/D_2');
        setTimeout(() => {
          callHelpNotificationSettings(i18n, store);
        }, 2000);
      }
      break;

    case 'editNotificationSettings':
      if (route.path === '/D_2') {
        callHelpEditNotificationSettings(i18n, store);
      } else {
        router.push('/D_2');
        setTimeout(() => {
          callHelpEditNotificationSettings(i18n, store);
        }, 2000);
      }
      break;

    case 'notificationSettingsGroup':
      if (route.path === '/D_2') {
        callHelpNotificationSettingsGroup(i18n, store);
      } else {
        router.push('/D_2');
        setTimeout(() => {
          callHelpNotificationSettingsGroup(i18n, store);
        }, 2000);
      }
      break;

    case 'notificationSettingsMemberManagement':
      if (route.path === '/D_2') {
        callHelpNotificationSettingsMember(i18n, store);
      } else {
        router.push('/D_2');
        setTimeout(() => {
          callHelpNotificationSettingsMember(i18n, store);
        }, 2000);
      }
      break;

    case 'deleteNotificationSettings':
      if (route.path === '/D_2') {
        callHelpDeleteNotificationSettings(i18n, store);
      } else {
        router.push('/D_2');
        setTimeout(() => {
          callHelpDeleteNotificationSettings(i18n, store);
        }, 2000);
      }
      break;

    case 'filterNotificationSettings':
      if (route.path === '/D_2') {
        callHelpFilterNotificationSettings(i18n, store);
      } else {
        router.push('/D_2');
        setTimeout(() => {
          callHelpFilterNotificationSettings(i18n, store);
        }, 2000);
      }
      break;

    //
    // 管制項目設定
    //
    case 'filterControlItemTree':
      if (route.path === '/A_1') {
        callHelpFilterControlItemTree(i18n);
      } else {
        router.push('/A_1');
        setTimeout(() => {
          callHelpFilterControlItemTree(i18n);
        }, 2000);
      }
      break;

    case 'ControlItemTab':
      if (route.path === '/A_1') {
        callHelpCreateControlItem(i18n, store);
      } else {
        router.push('/A_1');
        setTimeout(() => {
          callHelpCreateControlItem(i18n, store);
        }, 2000);
      }
      break;

    case 'addControlItem':
      if (route.path === '/A_1') {
        callHelpCreateControlItemV1(i18n, store);
      } else {
        router.push('/A_1');
        setTimeout(() => {
          callHelpCreateControlItemV1(i18n, store);
        }, 2000);
      }
      break;

    case 'controlItemSettingAndChartRule':
      if (route.path === '/A_1') {
        callHelpControlChartDataType(i18n, store);
      } else {
        router.push('/A_1');
        setTimeout(() => {
          callHelpControlChartDataType(i18n, store);
        }, 2000);
      }
      break;

    case 'doubleChart':
      if (route.path === '/A_1') {
        callHelpDoubleChart(i18n, store);
      } else {
        router.push('/A_1');
        setTimeout(() => {
          callHelpDoubleChart(i18n, store);
        }, 2000);
      }
      break;

    case 'copyControlItem':
      if (route.path === '/A_1') {
        callHelpCopy(i18n, store);
      } else {
        router.push('/A_1');
        setTimeout(() => {
          callHelpCopy(i18n, store);
        }, 2000);
      }
      break;

    case 'reCaculateontrolItem':
      if (route.path === '/A_1') {
        callHelpReCaculate(i18n, store);
      } else {
        router.push('/A_1');
        setTimeout(() => {
          callHelpReCaculate(i18n, store);
        }, 2000);
      }
      break;

    case 'editControlItem':
      if (route.path === '/A_1') {
        callHelpEdit(i18n, store);
      } else {
        router.push('/A_1');
        setTimeout(() => {
          callHelpEdit(i18n, store);
        }, 2000);
      }
      break;

    case 'deleteControlItem':
      if (route.path === '/A_1') {
        callHelpDelete(i18n, store);
      } else {
        router.push('/A_1');
        setTimeout(() => {
          callHelpDelete(i18n, store);
        }, 2000);
      }
      break;

    case 'explanationOfTheTerm':
      if (route.path === '/A_1') {
        callHelpExplanationOfTheTerm(i18n);
      } else {
        router.push('/A_1');
        setTimeout(() => {
          callHelpExplanationOfTheTerm(i18n);
        }, 2000);
      }
      break;

    //
    // 管制項目資訊
    //

    case 'filterControlProjectInfo':
      if (route.path === '/A_2') {
        callHelpFilterControlProject(i18n);
      } else {
        router.push('/A_2');
        setTimeout(() => {
          callHelpFilterControlProject(i18n);
        }, 2000);
      }
      break;

    case 'controlProjectInfo-View':
      if (route.path === '/A_2') {
        callHelpViewControlProject(i18n, store);
      } else {
        router.push('/A_2');
        setTimeout(() => {
          callHelpViewControlProject(i18n, store);
        }, 2000);
      }
      break;

    case 'hidePointOpen':
      if (route.path === '/A_2') {
        callHelpHidePoionOpen(i18n, store);
      } else {
        router.push('/A_2');
        setTimeout(() => {
          callHelpHidePoionOpen(i18n, store);
        }, 2000);
      }
      break;

    case 'clickChartSamplePoint':
      if (route.path === '/A_2') {
        clickChartSamplePoint(i18n, store);
      } else {
        router.push('/A_2');
        setTimeout(() => {
          clickChartSamplePoint(i18n, store);
        }, 2000);
      }
      break;

    //
    // 管制項目寫入
    //

    case 'controlItemEntry':
      if (route.path === '/A_6') {
        callControlItemEntry(i18n);
      } else {
        router.push('/A_6');
        setTimeout(() => {
          callControlItemEntry(i18n);
        }, 2000);
      }
      break;

    case 'controlItemEntryDataImport':
      if (route.path === '/A_6') {
        callDataImport(i18n, store);
      } else {
        router.push('/A_6');
        setTimeout(() => {
          callDataImport(i18n, store);
        }, 2000);
      }
      break;

    case 'multiDataImport':
      if (route.path === '/A_6') {
        callMultiDataImport(i18n, store);
      } else {
        router.push('/A_6');
        setTimeout(() => {
          callMultiDataImport(i18n, store);
        }, 2000);
      }
      break;

    case 'sampleManagement':
      if (route.path === '/A_7') {
        callSampleManagement(i18n, store);
      } else {
        router.push('/A_7');
        setTimeout(() => {
          callSampleManagement(i18n, store);
        }, 2000);
      }
      break;

    case 'sampleManagementEditPointProcess':
      if (route.path === '/A_7') {
        callSampleManagementEditPointProcess(i18n, store);
      } else {
        router.push('/A_7');
        setTimeout(() => {
          callSampleManagementEditPointProcess(i18n, store);
        }, 2000);
      }
      break;

    //
    // 變更履歷
    //

    case 'controlLineChangeHistory':
      if (route.path === '/A_4') {
        callControlLineChangeHistory(i18n, store);
      } else {
        router.push('/A_4');
        setTimeout(() => {
          callControlLineChangeHistory(i18n, store);
        }, 2000);
      }
      break;

    case 'controlChartRuleHistory':
      if (route.path === '/A_4') {
        callControlChartRuleHistory(i18n, store);
      } else {
        router.push('/A_4');
        setTimeout(() => {
          callControlChartRuleHistory(i18n, store);
        }, 2000);
      }
      break;

    //
    // 合圖查詢
    //

    case 'combinedQuery':
      if (route.path === '/A_5') {
        callCombinedQuery(i18n, store);
      } else {
        router.push('/A_5');
        setTimeout(() => {
          callCombinedQuery(i18n, store);
        }, 2000);
      }
      break;

    //
    // 製程能力分析
    //

    case 'processAnalysis':
      if (route.path === '/A_3') {
        callProcessAnalysis(i18n, store);
      } else {
        router.push('/A_3');
        setTimeout(() => {
          callProcessAnalysis(i18n, store);
        }, 2000);
      }
      break;

    case 'reportAdvanceSearch':
      if (route.path === '/A_3') {
        callProcessAnalysisAdvanceSearch(i18n, store);
      } else {
        router.push('/A_3');
        setTimeout(() => {
          callProcessAnalysisAdvanceSearch(i18n, store);
        }, 2000);
      }
      break;

    case 'chartQuery':
      if (route.path === '/A_3') {
        callProcessAnalysisChartQuery(i18n, store);
      } else {
        router.push('/A_3');
        setTimeout(() => {
          callProcessAnalysisChartQuery(i18n, store);
        }, 2000);
      }
      break;

    case 'processAnalysisAbnormal':
      if (route.path === '/A_3') {
        callProcessAnalysisAbnormal(i18n, store);
      } else {
        router.push('/A_3');
        setTimeout(() => {
          callProcessAnalysisAbnormal(i18n, store);
        }, 2000);
      }
      break;

    //
    // 異常原因管理
    //

    case 'abnormalReasonManagement':
      if (route.path === '/B_1') {
        callHelpAbnormalReasonManagement(i18n, store);
      } else {
        router.push('/B_1');
        setTimeout(() => {
          callHelpAbnormalReasonManagement(i18n, store);
        }, 2000);
      }
      break;

    case 'editAbnormalReasonManagement':
      if (route.path === '/B_1') {
        callHelpEditAbnormalReasonManagement(i18n, store);
      } else {
        router.push('/B_1');
        setTimeout(() => {
          callHelpEditAbnormalReasonManagement(i18n, store);
        }, 2000);
      }
      break;

    case 'deleteAbnormalReasonManagement':
      if (route.path === '/B_1') {
        callHelpDeleteAbnormalReasonManagement(i18n, store);
      } else {
        router.push('/B_1');
        setTimeout(() => {
          callHelpDeleteAbnormalReasonManagement(i18n, store);
        }, 2000);
      }
      break;

    case 'defectDefinition':
      if (route.path === '/B_1') {
        callHelpDefectDefinition(i18n, store);
      } else {
        router.push('/B_1');
        setTimeout(() => {
          callHelpDefectDefinition(i18n, store);
        }, 2000);
      }
      break;

    case 'editDefectDefinition':
      if (route.path === '/B_1') {
        callHelpEditDefectDefinition(i18n, store);
      } else {
        router.push('/B_1');
        setTimeout(() => {
          callHelpEditDefectDefinition(i18n, store);
        }, 2000);
      }
      break;

    case 'deleteDefectDefinition':
      if (route.path === '/B_1') {
        callHelpDeleteDefectDefinition(i18n, store);
      } else {
        router.push('/B_1');
        setTimeout(() => {
          callHelpDeleteDefectDefinition(i18n, store);
        }, 2000);
      }
      break;

    case 'inspection':
      if (route.path === '/B_1') {
        callHelpInspection(i18n, store);
      } else {
        router.push('/B_1');
        setTimeout(() => {
          callHelpInspection(i18n, store);
        }, 2000);
      }
      break;

    case 'editInspection':
      if (route.path === '/B_1') {
        callHelpEditInspection(i18n, store);
      } else {
        router.push('/B_1');
        setTimeout(() => {
          callHelpEditInspection(i18n, store);
        }, 2000);
      }
      break;

    case 'deleteInspection':
      if (route.path === '/B_1') {
        callHelpDeleteInspection(i18n, store);
      } else {
        router.push('/B_1');
        setTimeout(() => {
          callHelpDeleteInspection(i18n, store);
        }, 2000);
      }
      break;

    //
    // 層別設定
    //

    case 'levelProduct':
      if (route.path === '/B_3') {
        callHelpLevelProduct(i18n, store);
      } else {
        router.push('/B_3');
        setTimeout(() => {
          callHelpLevelProduct(i18n, store);
        }, 2000);
      }
      break;

    case 'editLevelProduct':
      if (route.path === '/B_3') {
        callHelpLevelProductEdit(i18n, store);
      } else {
        router.push('/B_3');
        setTimeout(() => {
          callHelpLevelProductEdit(i18n, store);
        }, 2000);
      }
      break;

    case 'deleteLevelProduct':
      if (route.path === '/B_3') {
        callHelpLevelProductDelete(i18n, store);
      } else {
        router.push('/B_3');
        setTimeout(() => {
          callHelpLevelProductDelete(i18n, store);
        }, 2000);
      }
      break;

    case 'levelMachine':
      if (route.path === '/B_3') {
        callHelpLevelMachine(i18n, store);
      } else {
        router.push('/B_3');
        setTimeout(() => {
          callHelpLevelMachine(i18n, store);
        }, 2000);
      }
      break;

    case 'editLevelMachine':
      if (route.path === '/B_3') {
        callHelpLevelMachineEdit(i18n, store);
      } else {
        router.push('/B_3');
        setTimeout(() => {
          callHelpLevelMachineEdit(i18n, store);
        }, 2000);
      }
      break;

    case 'deleteLevelMachine':
      if (route.path === '/B_3') {
        callHelpLevelMachineDelete(i18n, store);
      } else {
        router.push('/B_3');
        setTimeout(() => {
          callHelpLevelMachineDelete(i18n, store);
        }, 2000);
      }
      break;

    case 'levelProcess':
      if (route.path === '/B_3') {
        callHelpLevelProcess(i18n, store);
      } else {
        router.push('/B_3');
        setTimeout(() => {
          callHelpLevelProcess(i18n, store);
        }, 2000);
      }
      break;

    case 'editLevelProcess':
      if (route.path === '/B_3') {
        callHelpLevelProcessEdit(i18n, store);
      } else {
        router.push('/B_3');
        setTimeout(() => {
          callHelpLevelProcessEdit(i18n, store);
        }, 2000);
      }
      break;

    case 'deleteLevelProcess':
      if (route.path === '/B_3') {
        callHelpLevelProcessDelete(i18n, store);
      } else {
        router.push('/B_3');
        setTimeout(() => {
          callHelpLevelProcessDelete(i18n, store);
        }, 2000);
      }
      break;

    case 'levelParams':
      if (route.path === '/B_3') {
        callHelpLevelParams(i18n, store);
      } else {
        router.push('/B_3');
        setTimeout(() => {
          callHelpLevelParams(i18n, store);
        }, 2000);
      }
      break;

    case 'editLevelParams':
      if (route.path === '/B_3') {
        callHelpLevelParamsEdit(i18n, store);
      } else {
        router.push('/B_3');
        setTimeout(() => {
          callHelpLevelParamsEdit(i18n, store);
        }, 2000);
      }
      break;

    case 'deleteLevelParams':
      if (route.path === '/B_3') {
        callHelpLevelParamsDelete(i18n, store);
      } else {
        router.push('/B_3');
        setTimeout(() => {
          callHelpLevelParamsDelete(i18n, store);
        }, 2000);
      }
      break;

    //
    // 動態欄位設定
    //

    case 'dynamicFieldSettings':
      if (route.path === '/B_4') {
        callHelpDynamicFieldSettings(i18n, store);
      } else {
        router.push('/B_4');
        setTimeout(() => {
          callHelpDynamicFieldSettings(i18n, store);
        }, 2000);
      }
      break;

    //
    // 管制圖規則
    //

    case 'controlChartRules':
      if (route.path === '/B_2') {
        callHelpControlChartRules(i18n, store);
      } else {
        router.push('/B_2');
        setTimeout(() => {
          callHelpControlChartRules(i18n, store);
        }, 2000);
      }
      break;

    case 'editAndDeleteControlChartRules':
      if (route.path === '/B_2') {
        callHelpControlChartRulesEditAndDelete(i18n, store);
      } else {
        router.push('/B_2');
        setTimeout(() => {
          callHelpControlChartRulesEditAndDelete(i18n, store);
        }, 2000);
      }
      break;

    //
    // 標準樣本設定
    //

    case 'goldenSampleSetting':
      if (route.path === '/B_6') {
        callHelpGoldenSampleSetting(i18n, store);
      } else {
        router.push('/B_6');
        setTimeout(() => {
          callHelpGoldenSampleSetting(i18n, store);
        }, 2000);
      }
      break;

    case 'goldenSampleSettingEditAndDelete':
      if (route.path === '/B_6') {
        callHelpGoldenSampleSettingEditAndDelete(i18n, store);
      } else {
        router.push('/B_6');
        setTimeout(() => {
          callHelpGoldenSampleSettingEditAndDelete(i18n, store);
        }, 2000);
      }
      break;

    //
    // 制程能力等級
    //

    case 'processAnalysisRanks':
      if (route.path === '/B_8') {
        callHelpProcessAnalysisRanks(i18n, store);
      } else {
        router.push('/B_8');
        setTimeout(() => {
          callHelpProcessAnalysisRanks(i18n, store);
        }, 2000);
      }
      break;

    case 'processAnalysisRanksEditAndDelete':
      if (route.path === '/B_8') {
        callHelpProcessAnalysisRanksEditAndDelete(i18n, store);
      } else {
        router.push('/B_8');
        setTimeout(() => {
          callHelpProcessAnalysisRanksEditAndDelete(i18n, store);
        }, 2000);
      }
      break;

    //
    // 製程能力規則
    //

    case 'processAnalysisRule':
      if (route.path === '/B_9') {
        callHelpProcessAnalysisRule(i18n, store);
      } else {
        router.push('/B_9');
        setTimeout(() => {
          callHelpProcessAnalysisRule(i18n, store);
        }, 2000);
      }
      break;

    case 'processAnalysisRuleEditAndDelete':
      if (route.path === '/B_9') {
        callHelpProcessAnalysisRuleEditAndDelete(i18n, store);
      } else {
        router.push('/B_9');
        setTimeout(() => {
          callHelpProcessAnalysisRuleEditAndDelete(i18n, store);
        }, 2000);
      }
      break;

    //
    // Indicator設定
    //

    case 'indicator':
      if (route.path === '/B_10') {
        callHelpIndicator(i18n);
      } else {
        router.push('/B_10');
        setTimeout(() => {
          callHelpIndicator(i18n);
        }, 2000);
      }
      break;

    case 'indicatorQA':
      if (route.path === '/A_2') {
        callHelpIndicatorQA(i18n);
      } else {
        router.push('/A_2');
        setTimeout(() => {
          callHelpIndicatorQA(i18n);
        }, 2000);
      }
      break;

    //
    // 排程設定
    //

    case 'scheduleSettings':
      if (route.path === '/B_11') {
        callHelpScheduleSettings(i18n, store);
      } else {
        router.push('/B_11');
        setTimeout(() => {
          callHelpScheduleSettings(i18n, store);
        }, 2000);
      }
      break;

    case 'scheduleSettingsList':
      if (route.path === '/B_11') {
        callHelpScheduleSettingsList(i18n, store);
      } else {
        router.push('/B_11');
        setTimeout(() => {
          callHelpScheduleSettingsList(i18n, store);
        }, 2000);
      }
      break;

    //
    // OCAP
    //

    case 'stageSetting':
      if (route.path === '/F_1') {
        callHelpStageSetting(i18n, store);
      } else {
        router.push('/F_1');
        setTimeout(() => {
          callHelpStageSetting(i18n, store);
        }, 2000);
      }
      break;

    case 'editDeleteStageSetting':
      if (route.path === '/F_1') {
        callHelpEditDeleteStageSetting(i18n, store);
      } else {
        router.push('/F_1');
        setTimeout(() => {
          callHelpEditDeleteStageSetting(i18n, store);
        }, 2000);
      }
      break;

    case 'flowSetting':
      if (route.path === '/F_2') {
        callHelpFlowSetting(i18n, store);
      } else {
        router.push('/F_2');
        setTimeout(() => {
          callHelpFlowSetting(i18n, store);
        }, 2000);
      }
      break;

    case 'stageSettingExample':
      if (route.path === '/F_1') {
        callHelpOCAPSettingExample(i18n, store);
      } else {
        router.push('/F_1');
        setTimeout(() => {
          callHelpOCAPSettingExample(i18n, store);
        }, 2000);
      }
      break;

    case 'signatureQuery':
      if (route.path === '/F_3') {
        callHelpSignatureQuery(i18n);
      } else {
        router.push('/F_3');
        setTimeout(() => {
          callHelpSignatureQuery(i18n);
        }, 2000);
      }
      break;

    case 'signatureQueryHandle':
      if (route.path === '/F_3') {
        callHelpSignatureQueryHandle(i18n, store);
      } else {
        router.push('/F_3');
        setTimeout(() => {
          callHelpSignatureQueryHandle(i18n, store);
        }, 2000);
      }
      break;

    //
    // 警報管理
    //

    case 'alarmList':
      if (route.path === '/D_1') {
        callHelpAlertList(i18n);
      } else {
        router.push('/D_1');
        setTimeout(() => {
          callHelpAlertList(i18n);
        }, 2000);
      }
      break;

    case 'alarmListAdvanceSearch':
      if (route.path === '/D_1') {
        callHelpAlertListAdvanceSearch(i18n, store);
      } else {
        router.push('/D_1');
        setTimeout(() => {
          callHelpAlertListAdvanceSearch(i18n, store);
        }, 2000);
      }
      break;

    case 'alarmListLamp':
      if (route.path === '/D_1') {
        callHelpAlertListLamp(i18n, store);
      } else {
        router.push('/D_1');
        setTimeout(() => {
          callHelpAlertListLamp(i18n, store);
        }, 2000);
      }
      break;

    case 'alarmListHandle':
      if (route.path === '/D_1') {
        callHelpAlertListHandle(i18n, store);
      } else {
        router.push('/D_1');
        setTimeout(() => {
          callHelpAlertListHandle(i18n, store);
        }, 2000);
      }
      break;

    case 'processAnalysisAlarmList':
      if (route.path === '/D_3') {
        callProcessAnalysisAlarmList(i18n, store);
      } else {
        router.push('/D_3');
        setTimeout(() => {
          callProcessAnalysisAlarmList(i18n, store);
        }, 2000);
      }
      break;

    //
    // 資料處理-資料匯入
    //

    case 'dataImport':
      if (route.path === '/E_1') {
        callHelpDataProcessingImport(i18n);
      } else {
        router.push('/E_1');
        setTimeout(() => {
          callHelpDataProcessingImport(i18n);
        }, 2000);
      }
      break;

    case 'dataImportAbnormalReason':
      if (route.path === '/E_1') {
        callHelpDataImportAbnormalReason(i18n);
      } else {
        router.push('/E_1');
        setTimeout(() => {
          callHelpDataImportAbnormalReason(i18n);
        }, 2000);
      }
      break;

    case 'dataImportDefect':
      if (route.path === '/E_1') {
        callHelpDataImportDefect(i18n);
      } else {
        router.push('/E_1');
        setTimeout(() => {
          callHelpDataImportDefect(i18n);
        }, 2000);
      }
      break;

    case 'dataImportInspection':
      if (route.path === '/E_1') {
        callHelpDataImportInspection(i18n);
      } else {
        router.push('/E_1');
        setTimeout(() => {
          callHelpDataImportInspection(i18n);
        }, 2000);
      }
      break;

    case 'dataImportControlChartRules':
      if (route.path === '/E_1') {
        callHelpDataImportControlChartRules(i18n);
      } else {
        router.push('/E_1');
        setTimeout(() => {
          callHelpDataImportControlChartRules(i18n);
        }, 2000);
      }
      break;

    case 'dataImportUserSettings':
      if (route.path === '/E_1') {
        callHelpDataImportUserSettings(i18n);
      } else {
        router.push('/E_1');
        setTimeout(() => {
          callHelpDataImportUserSettings(i18n);
        }, 2000);
      }
      break;

    case 'dataImportUserGroup':
      if (route.path === '/E_1') {
        callHelpDataImportUserGroup(i18n);
      } else {
        router.push('/E_1');
        setTimeout(() => {
          callHelpDataImportUserGroup(i18n);
        }, 2000);
      }
      break;

    case 'dataImportParameters':
      if (route.path === '/E_1') {
        callHelpDataImportParameters(i18n);
      } else {
        router.push('/E_1');
        setTimeout(() => {
          callHelpDataImportParameters(i18n);
        }, 2000);
      }
      break;

    case 'dataImportGroup':
      if (route.path === '/E_1') {
        callHelpDataImportGroup(i18n);
      } else {
        router.push('/E_1');
        setTimeout(() => {
          callHelpDataImportGroup(i18n);
        }, 2000);
      }
      break;

    case 'dataImportMachine':
      if (route.path === '/E_1') {
        callHelpDataImportMachine(i18n);
      } else {
        router.push('/E_1');
        setTimeout(() => {
          callHelpDataImportMachine(i18n);
        }, 2000);
      }
      break;

    case 'dataImportProduct':
      if (route.path === '/E_1') {
        callHelpDataImportProduct(i18n);
      } else {
        router.push('/E_1');
        setTimeout(() => {
          callHelpDataImportProduct(i18n);
        }, 2000);
      }
      break;

    //
    // 資料處理-管制項目匯入
    //

    case 'controlItemImport':
      if (route.path === '/E_2') {
        callHelpControlItemImport(i18n);
      } else {
        router.push('/E_2');
        setTimeout(() => {
          callHelpControlItemImport(i18n);
        }, 2000);
      }
      break;

    case 'controlItemBatchImport':
      if (route.path === '/E_2') {
        callHelpBatchImport(i18n, store);
      } else {
        router.push('/E_2');
        setTimeout(() => {
          callHelpBatchImport(i18n, store);
        }, 2000);
      }
      break;

    //
    // SPC統計管制圖 說明
    //
    case 'xBarChart':
      if (route.path === '/A_1') {
        callxBarChart(i18n, store);
      } else {
        router.push('/A_1');
        setTimeout(() => {
          callxBarChart(i18n, store);
        }, 2000);
      }
      break;

    default:
      break;
  }
}
